import { Controller } from "@hotwired/stimulus"
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';

export default class extends Controller {
  static targets = ["calendar","doctorSelect"]

  connect() {
    console.log("FullCalendar Appointment Stimulus controller connected")

    this.initializeSelect2()

    this.calendar = new Calendar(this.calendarTarget, {
      plugins: [ dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin ],
      initialView: 'dayGridMonth',
      slotDuration: '00:30:00',
      slotMinTime: '08:00:00',
      slotMaxTime: '17:00:00',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,listWeek'
      },
      selectable: true,
      editable: false,
      eventClick: this.handleEventClick.bind(this),
      events: this.fetchEvents.bind(this)
    })

    this.calendar.render()
  }

  disconnect() {
    // Clean up Select2 when the controller is disconnected
    if (this.hasDoctorSelectTarget) {
      $(this.doctorSelectTarget).select2('destroy')
    }
  }
  
  fetchEvents(info, successCallback, failureCallback) {

    const doctorId = this.doctorSelectTarget ? this.doctorSelectTarget.value : '';

    const request= doctorId ? `/appointments/practitioner/${doctorId}`:`/appointments/events.json`

    console.log("Displaying appointments for ID: " + doctorId)

    fetch(request)
    .then(response => response.json())
      .then(data => {
        const events = data.map(apt => ({
          id: apt.id,
          title: apt.title, //`${ts.start} - ${ts.end}`,
          start: apt.start,
          end: apt.end,
          //color: apt.status === 'blocked' ? 'red' : 'green',
          //backgroundColor: apt.status === 'blocked' ? 'red' : 'green',
          className: apt.status === 'proposed' ? 'text-success' : apt.status === 'cancelled' ? 'text-danger' : 'text-info' , 

          //url: apt.url
          url: `/appointments/${apt.id}`
        }))
        successCallback(events)
      })
      .catch(error => {
        console.error("Error fetching appointments:", error)
        failureCallback(error)
      })
  }

  handleEventClick(info) {
    info.jsEvent.preventDefault() // Prevent browser from following the link
    window.location.href = info.event.url // Navigate to the appointment edit page
    console.log("clicked eventd")

  //   info.jsEvent.preventDefault(); // don't let the browser navigate
  //   //console.log("calendar clicked");
  //   //return
  //   overlay.src = '/appointments/' + info.event.id + '/edit';
  //   // const modal = new window.bootstrap.Modal("");
  //   // modal.show();
  //   // if (!info.event.url) {
  //   //   window.open(info.event.url, '_blank');
  //   //   info.jsEvent.preventDefault();
  //   // } else {
  //   //   const template = getTemplate(info.event);
  //   //   document.querySelector(
  //   //     Selectors.EVENT_DETAILS_MODAL_CONTENT
  //   //   ).innerHTML = template;
  //   //   const modal = new window.bootstrap.Modal(eventDetailsModal);
  //   //   modal.show();
  //   // }
  // }
 
  }

  refresh(e) {
    if (e.detail.success) {
      this.calendar.refetchEvents();
    }
  }

  refreshEvents() {
    this.calendar.refetchEvents();
  }

  initializeSelect2() {
    if (this.hasDoctorSelectTarget) {
      $(this.doctorSelectTarget).select2({
        theme: 'bootstrap-5',
        width: '25%',
        // Add any other Select2 options you need
      }).on('select2:select select2:unselect', (e) => {
        this.refreshEvents()
      })
    }
  }

  showToast(type, message) {
    // Assuming you have a toast component or notification system
    // Adjust this according to your notification system
    const event = new CustomEvent('toast', {
      detail: { type, message }
    })
    window.dispatchEvent(event)
  }

}
